import { render, staticRenderFns } from "./deliveryList.vue?vue&type=template&id=7a13eace&scoped=true&"
import script from "./deliveryList.vue?vue&type=script&lang=js&"
export * from "./deliveryList.vue?vue&type=script&lang=js&"
import style0 from "./deliveryList.vue?vue&type=style&index=0&id=7a13eace&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a13eace",
  null
  
)

export default component.exports